import { render, staticRenderFns } from "./CurrenciesDirect.vue?vue&type=template&id=58c2082e&scoped=true&"
import script from "./CurrenciesDirect.vue?vue&type=script&lang=js&"
export * from "./CurrenciesDirect.vue?vue&type=script&lang=js&"
import style0 from "./CurrenciesDirect.vue?vue&type=style&index=0&id=58c2082e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2082e",
  null
  
)

export default component.exports